/**
 * Dev-only logger. Stripped from production builds at the call-site:
 * the `process.env.NODE_ENV` check is folded by CRA's webpack, so
 * the console call disappears in `yarn build`.
 *
 * - `log.warn(...)`  → dev only; vanishes in prod (non-critical noise)
 * - `log.info(...)`  → dev only; vanishes in prod (informational)
 * - `log.error(...)` → ALWAYS surfaces (production observability matters)
 */
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  error: (...args) => {
    // Errors are always surfaced — production observability matters.
    console.error(...args);
  },
};
